<cs-icon name="sync"></cs-icon>